import { render } from "./ListInspection.vue?vue&type=template&id=7b4fd80e"
import script from "./ListInspection.vue?vue&type=script&lang=ts"
export * from "./ListInspection.vue?vue&type=script&lang=ts"

import "./ListInspection.vue?vue&type=style&index=0&id=7b4fd80e&lang=scss"
script.render = render

export default script